<template>
  <div style="width: 100%;height: 100%">
    <video :controls="option.attribute.isControls" :muted="!option.attribute.muted"
      :autoplay="option.attribute.autoplay" :loop="option.attribute.loop" style="width: 100%;height: 100%" controls>
      <source :src="option.attribute.source === 1 ? option.attribute.url : fileUrl + option.attribute.fileUrl"
        type="video/mp4">
    </video>
  </div>
</template>

<script>

import { fileUrl } from "/env";

export default {
  name: "cpt-video-player",
  props: { option: Object, current: Object },
  data() {
    return {
      fileUrl
    }
  },
}
</script>

<style scoped></style>
